import { Grid, useEventCallback } from '@mui/material';
import { Form, Formik } from 'formik';
import ModalInfoCertification from 'front-office/components/shared/info-certificate';
import ModalCertificate from 'front-office/components/statements/request-certificate-modal';
import ModalPrintSuccess from 'front-office/components/shared/request-print';
import { Fragment, useCallback, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import * as yup from 'yup';
import StatementsForm from 'front-office/components/statements';
import { StatementsCrumbs } from 'front-office/constants/statements-crumbs';
import { transformRequestStatementsData } from 'front-office/utils/transform-request-statements';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseCertificateGeneric } from 'shell/models/response-certificate-generic';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
// import { openPdf } from 'shell/utils/open-pdf';
import { transformResponseRequestCertificateGeneric } from 'front-office/utils/transform-response-certificate-generic';
import { validationCertificationSchema } from 'front-office/constants/validation-shema/certification-schema';
import PageButtons from 'front-office/components/shared/buttons-certificate';
import { CommonRequestCertificateInterface } from 'front-office/view-models/common-certificate-form';
import { ModalViewerPDF } from 'shell/components/shared/pdf-modal';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import PmiTitle from 'shell/components/shared/title';
// import { regexOnlyNumber } from 'shell/constants/regex';

enum Declaration {
  textDeclaration = `consapevole delle pene stabilite per le false attestazioni e le mendaci dichiarazioni dagli articoli 483, 495 e 496 del codice penale, dichiaro sotto la mia personale responsabilità\r\nAi sensi dell'art.8 della legge 15/12/1990 n.386\r\ndi aver ricevuto la somma di Euro     a pagamento dell'assegno bancario N°     della Banca       di                  dal Sig.              nato a              il      in quanto l'assegno sopra indicato era protestato. Inoltre dichiaro di aver ricevuto il 10 per cento dell'importo dell'assegno a titolo di penale e che sono state pagate tutte le spese di protesto nonche' interessi e ogni altro onere di legge`,
}
const validationSchema = yup.object().shape({
  ...validationCertificationSchema,
  will: yup.object().nullable().shape({
    // repertoire: yup.string().nullable().matches(regexOnlyNumber, 'Campo numerico'),
  }),
});

const StatementsPage = (): React.ReactElement => {
  const [certificatePdf, getPdfCertificate] = useHttpFetch<
    HttpResponse<ResponseCertificateGeneric>,
    HttpResponse<ResponseCertificateGeneric>
  >(`${__CERTIFICATION_API_URL__}/richiesta-certificato/generico`, {
    onBootstrap: false,
    options: {
      method: 'POST',
    },
    transformer: transformResponseRequestCertificateGeneric,
  });

  // Casted response certificate
  const dataCertificate = certificatePdf.data as HttpResponse<ResponseCertificateGeneric>;

  const { userProfile } = useUserProfile();
  const cashManagement = userProfile?.datiLogin?.profile?.servizio?.gestioneCassa;

  // ModalCertificate
  const [open, setOpen] = useState<boolean>(false);

  // ModalPrintSuccess
  const [modalPrintSuccess, setModalPrintSuccess] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  // InfoCertification
  const [infoCertification, setInfoCertification] = useState<{ open: boolean; total?: number }>({
    open: false,
  });

  const [pdfModal, setPdfModal] = useState({ data: '', open: false, name: '' });

  // Handle the submit
  const handleSubmit = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const onRequestCertificate = useEventCallback((values: StatementsFormVM) => {
    const data = transformRequestStatementsData(values);

    (
      getPdfCertificate({ data }) as ResponsePromise<
        HttpResponse<ResponseCertificateGeneric>,
        HttpResponse<ResponseCertificateGeneric>
      >
    ).then((response) => {
      const responseCasted = response as HttpResponse<ResponseCertificateGeneric>;
      const pdfCertificate = responseCasted?.payload?.contenutoPdfCertificato;

      const { modality } = values;

      const {
        amountRightsSecretariat = 0.0,
        amountRightsCivilState = 0.0,
        amountFixedRights = 0.0,
        amountExpenses = 0.0,
        amountTaxStamp = 0.0,
      } = modality || {};

      const rights =
        amountExpenses +
        amountFixedRights +
        amountRightsCivilState +
        amountRightsSecretariat +
        amountTaxStamp;

      // close ModalCertificate
      setOpen(false);

      if (pdfCertificate) {
        // openPdf(pdfCertificate);
        setPdfModal({
          data: pdfCertificate,
          name: 'Dichiarazione_Sostitutiva_Notorietà',
          open: true,
        });
      }

      const parsedTotal = values?.certificateInternOnly
        ? Number.parseFloat('0,00')
        : Number.parseFloat(rights?.toString() || '0,00');

      // const total = (values?.payment || 0) + parsedTotal;

      // setFieldValue('payment', total);

      //open ModalPrintSuccess
      setModalPrintSuccess({ open: false, total: parsedTotal });
      // context.setValues({
      //   ...values,
      //   declaration: '',
      //   textDeclaration: Declaration.textDeclaration,
      //   declarationAdded: '',
      // });
    });
  });

  const onYes = useEventCallback(
    (
      values: CommonRequestCertificateInterface,
      setFieldValue: (
        key: keyof CommonRequestCertificateInterface,
        value: CommonRequestCertificateInterface[keyof CommonRequestCertificateInterface]
      ) => void
    ) => {
      const total = (values?.payment || 0) + (modalPrintSuccess?.total || 0);

      setFieldValue('payment', total);

      // close ModalPrintSuccess
      setModalPrintSuccess({ open: false, total: undefined });

      //open InfoCertification
      setInfoCertification({ open: true, total: modalPrintSuccess.total });
    }
  );

  return (
    <Fragment>
      <Breadcrumbs items={StatementsCrumbs} base="sportello" />
      <div>
        <PmiTitle title="Dichiarazioni" />
      </div>
      <div className="pmi-mt-4">
        <div className="pmi-mt-2">
          <Formik
            validationSchema={validationSchema}
            initialValues={
              {
                accountholder: { sameApplicant: true },
                payment: 0,
                certificateInternOnly: cashManagement !== 'S' ? true : false,
                intendedUse: '0',
                textDeclaration: Declaration.textDeclaration,
                generality: {
                  isForeignDocument: DocumentRadioCertificate.IdentityCard,
                },
              } as StatementsFormVM
            }
            enableReinitialize
            onSubmit={handleSubmit}
            validateOnChange
            validateOnBlur
            // validateOnMount
          >
            <Form>
              <Grid container spacing={1}>
                <Grid item xs={12} md={3}>
                  <PageButtons handleRequestCertificate={handleSubmit} label="Dichiarazione" />
                </Grid>
                <Grid item xs={12} md={9}>
                  <div className="pmi-px-md-4">
                    <StatementsForm />
                  </div>
                </Grid>
              </Grid>
              <ModalCertificate
                open={open}
                onClose={setOpen}
                onRequestCertificate={onRequestCertificate}
              />
              <ModalPrintSuccess
                open={modalPrintSuccess.open}
                onClose={() => setModalPrintSuccess({ open: false })}
                onYes={onYes}
              />
              <ModalInfoCertification
                open={infoCertification.open}
                onClose={() => setInfoCertification({ open: false })}
                amountCertifate={infoCertification.total?.toFixed(2)}
                title={dataCertificate?.payload?.numeroIdentificativoDocumento}
              />
              <ModalViewerPDF
                open={pdfModal.open}
                data={pdfModal.data}
                name={pdfModal.name}
                title="Certificazione"
                onClose={() => {
                  setPdfModal({ data: '', open: false, name: '' });
                  setModalPrintSuccess((oldState) => ({ ...oldState, open: true }));
                }}
              />
            </Form>
          </Formik>
        </div>
      </div>
    </Fragment>
  );
};

StatementsPage.displayName = 'Statements page';

export default StatementsPage;
